import { render, staticRenderFns } from "./chat-status-button-faceplate.vue?vue&type=template&id=ed33a306"
import script from "./chat-status-button-faceplate.vue?vue&type=script&lang=js"
export * from "./chat-status-button-faceplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports